import { Dialog } from '@cimplico/components';
import { toastNotification } from '../../../components/toast/Toast';
import { useUpdateWorkpapers } from '../../../queries/use-update-workpapers';
import { WorkpaperStatusEnum } from '../../../types/workpaper';

type ReopenWorkpaperDialogProps = {
    workpaperId: string;
    isOpen: boolean;
    onClose: () => void;
};

function ReopenWorkpaperDialog({ workpaperId, isOpen, onClose }: ReopenWorkpaperDialogProps): JSX.Element {
    const reopenWorkpaperQuery = useUpdateWorkpapers();

    function reopenWorkpaper(): void {
        reopenWorkpaperQuery.mutate([{ id: workpaperId, fields: { status: WorkpaperStatusEnum.ACTIVE } }], {
            onSuccess: () => {
                onClose();
                toastNotification('success', `Workpaper is reopened!`);
            },
            onError: () => {
                toastNotification('error', `Workpaper cannot be reopened!`);
            },
        });
    }

    return (
        <Dialog
            title="Reopen Workpaper"
            description="Do you want to reopen this workpaper? This workpaper will become active again."
            onClose={onClose}
            onPrimaryActionClick={reopenWorkpaper}
            onSecondaryActionClick={onClose}
            isOpen={isOpen}
            primaryAction="Reopen"
            secondaryAction="Cancel"
            type="error"
            isLoading={reopenWorkpaperQuery.isLoading}
        />
    );
}

export default ReopenWorkpaperDialog;
